import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_PartialCorrect extends QuestionPassState {
    id = QuestionPassStateId.PartialCorrect;
    name = 'Teilweise richtig beantwortet';
    color = 'warning';
    orderInProgressbar = 5;
}
